export const DASHBOARD_REQUEST = 'DASHBOARD_REQUEST';
export const DASHBOARD_SUCCESS = 'DASHBOARD_SUCCESS';
export const DASHBOARD_FAILURE = 'DASHBOARD_FAILURE';
export const DASHBOARDSTATUS_REQUEST = 'DASHBOARDSTATUS_REQUEST';
export const DASHBOARDSTATUS_SUCCESS = 'DASHBOARDSTATUS_SUCCESS';
export const DASHBOARDSTATUS_FAILURE = 'DASHBOARDSTATUS_FAILURE';